module.exports = __webpack_public_path__ + "static/media/sd.560abc60.svg";